import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Container, Button, Row, Col, Form, Spinner } from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import { API_URL } from "../../utils/config";
import { Editor } from "react-draft-wysiwyg"; // Import your rich text editor component here
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const NotificationsManage = () => {
  const [courses, setCourses] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(
    localStorage.getItem("companyID")
  );
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    company: localStorage.getItem("companyID"),
    thumbnail: null,
  });
  const [isEdit, setIsEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  // Initialize editor state with empty content
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  useEffect(() => {
    fetchCompanies();
  }, []);
  // Function to handle changes in the editor state
  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    setFormData({
      ...formData,
      description: draftToHtml(convertToRaw(editorState.getCurrentContent())),
    });
  };

  useEffect(() => {
    fetchCourses(currentPage);
  }, [currentPage, selectedCompany]); // Add formData.company to the dependencies

  const fetchCourses = async (page) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    let apiUrl = `${API_URL}/admin/notification?page=${page}&limit=5`;
    if (selectedCompany) {
      apiUrl += `&companyId=${selectedCompany}`; // Append company ID if selected
    }

    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (response.status === 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => {
        setCourses(result.infographics);
        setTotalPages(result.totalPages);
        setCurrentPage(result.currentPage);
      })
      .catch((error) => console.error(error));
  };

  const fetchCompanies = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(`${API_URL}/admin/companies`, requestOptions)
      .then((response) => {
        if (response.status == 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => setCompanies(result))
      .catch((error) => console.error(error));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      try {
        const logoResponse = await fetch(
          `${API_URL}/notifications`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("token"), // Replace with your JWT token
            },
            body: JSON.stringify({
              platform: formData.platform,
              title: "New Notification",
              description: formData.description,
              company: formData.company,
              userID: localStorage.getItem("userId"), // Assuming you have the userID
            }),
          }
        );
        if (logoResponse.ok) {
          alert("Notification created successfully!!");
          setFormData({
            title: "",
            description: "",
            company: localStorage.getItem("companyID"),
            userID: localStorage.getItem("userId"),
            thumbnail: null,
          });
          setEditorState(() => EditorState.createEmpty());
          setImage(null);
          setImageUrl("");
        } else {
          alert("Failed to create notification, please try again!!");
          throw new Error("Failed to upload logo");
        }
      } catch (error) {
        console.error("Error sending notification:", error);
      }
      await fetchCourses();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      alert("Failed to create notification, please try again!!");
      setIsLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
      const formdata = new URLSearchParams();
      if (formData.company) {
        formdata.append("isPublic", false);
        formdata.append("company", formData.company);
      } else {
        formdata.append("isPublic", true);
      }
      formdata.append("title", formData.title);
      formdata.append("description", formData.description);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      console.log(formData.courseIdToUpdate);
      const response = await fetch(
        `${API_URL}/admin/info/${formData.courseIdToUpdate}`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error("Failed to update course");
      }

      setFormData({
        title: "",
        description: "",
        company: localStorage.getItem("companyID"),
        userID: localStorage.getItem("userId"),
        thumbnail: null,
      });
      alert("Notifications updated successfully!");
      await fetchCourses();
      setIsEdit(false);
      setIsLoading(false);
    } catch (error) {
      console.log();
      alert("Failed to update course, please try again!");
      setIsLoading(false);
    }
  };

  const handleEdit = (course) => {
    setFormData({
      ...formData,
      title: course.title,
      description: course.description,
      company: course.isPublic ? "" : course.company._id,
      courseIdToUpdate: course._id,
    });
    setIsEdit(true);
  };

  const handleDelete = async (courseId) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this infographic?"
    );
    if (!isConfirmed) return;
    try {
      const response = await fetch(
        `${API_URL}/info/${courseId}`,
        {
          method: "DELETE",
          headers: { Authorization: localStorage.getItem("token") },
        }
      );
      if (response.ok) {
        alert("Infographic deleted successfully");
        await fetchCourses();
      } else {
        alert("Failed to delete infographic");
      }
    } catch (error) {
      console.error("Error deleting infographic:", error);
      alert("Failed to delete infographic");
    }
  };

  const handleFileChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleUploadImage = async () => {
    setIsLoading(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("image", image);

      const response = await fetch(
        `${API_URL}/upload-notification`,
        {
          method: "POST",
          body: formDataToSend,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to upload image");
      }

      const data = await response.json();
      setImageUrl(data.imageUrl);
    } catch (error) {
      console.error("Error uploading image:", error);
    }

    setIsLoading(false);
  };

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(`${API_URL}/${imageUrl}`)
      .then(() => {
        alert("Image link copied to clipboard!");
      })
      .catch((err) => {
        console.error("Could not copy text: ", err);
      });
  };

  return (
    <Grid
      item
      xs={10}
      style={{
        padding: "20px",
        height: "100%",
        fontFamily: "Noto Sans",
        fontWeight: "500",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container fluid style={{ height: "100%" }}>
        <Row>
          <Col
            xs={8}
            style={{
              flex: 1,
              overflowY: "scroll",
              height: "90vh",
              width: "100%",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "100%" }}>
              <div style={{ height: "10px" }} />
              {courses.length > 0 ? (
                <table
                  style={{ flex: 1 }}
                  className="table table-striped table-bordered table-hover"
                >
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Client</th>
                      {/* <th>Actions</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {courses.map((course) => {
                      return (
                        <tr key={course._id}>
                          <td>{course.description}</td>
                          <td>
                            {course.isPublic ? "Global" : course.company.name}
                          </td>
                          {/* <td>
                                                <EditNoteIcon onClick={() => handleEdit(course)} style={{ color: 'green', cursor: 'pointer' }} />
                                                <DeleteSweepIcon onClick={() => handleDelete(course._id)} style={{ color: 'red', cursor: 'pointer' }} />
                                            </td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <div style={{ margin: "20px", textAlign: "center" }}>
                  No notifications found, please try again!
                </div>
              )}
            </div>
            <nav aria-label="Courses pagination">
              <ul className="pagination">
                {[...Array(totalPages).keys()].map((page) => (
                  <li
                    key={page}
                    className={`page-item ${
                      currentPage === page + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(page + 1)}
                    >
                      {page + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </Col>
          <Col
            xs={5}
            style={{
              height: "90vh",
              overflowY: "scroll",
              display: "flex",
              alignItems: "start",
              flexDirection: "column",
              justifyContent: "start",
            }}
          >
            <h4 style={{ marginTop: "15px" }}>Create Notification</h4>
            <Form
              style={{ fontFamily: "Noto Sans" }}
              className="w-100"
              onSubmit={isEdit ? handleUpdate : handleSubmit}
            >
              <div style={{ height: "10px" }} />
              {formData.platform === "email" ? (
                <div>
                  <Form.Group controlId="formFile">
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      Select Image
                    </Form.Label>
                    <Form.Control type="file" onChange={handleFileChange} />
                  </Form.Group>
                  <Button
                    style={{
                      fontWeight: "600",
                      borderRadius: "20px",
                      marginTop: "15px",
                    }}
                    className="w-100"
                    variant="primary"
                    onClick={handleUploadImage}
                    disabled={!image || isLoading}
                  >
                    {isLoading ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : null}
                    Upload Image
                  </Button>
                  <div style={{ height: "5px" }} />
                  {imageUrl && (
                    <div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <span style={{ marginRight: "10px", fontSize: "10px" }}>
                          ${API_URL}/{imageUrl}
                        </span>
                        <Button variant="primary" onClick={handleCopyLink}>
                          Copy Link
                        </Button>
                      </div>
                    </div>
                  )}
                  <div style={{ height: "10px" }} />
                </div>
              ) : null}

              {formData.platform === "email" ? (
                <div style={{ height: "320px" }}>
                  <Editor
                    editorState={editorState}
                    onEditorStateChange={onEditorStateChange}
                    wrapperClassName="wrapper-class"
                    editorClassName="editor-class"
                    toolbarClassName="toolbar-class"
                    toolbar={{
                      options: [
                        "inline",
                        "blockType",
                        "fontSize",
                        "fontFamily",
                        "list",
                        "textAlign",
                        "colorPicker",
                        "link",
                        "embedded",
                        "image",
                        "remove",
                        "history",
                      ],
                      inline: {
                        inDropdown: false,
                        options: [
                          "bold",
                          "italic",
                          "underline",
                          "strikethrough",
                          "monospace",
                        ],
                        className: undefined,
                        component: undefined,
                        dropdownClassName: undefined,
                      },
                      list: {
                        inDropdown: false,
                        className: undefined,
                        component: undefined,
                        dropdownClassName: undefined,
                      },
                      textAlign: {
                        inDropdown: false,
                        className: undefined,
                        component: undefined,
                        dropdownClassName: undefined,
                      },
                      link: {
                        inDropdown: false,
                        className: undefined,
                        component: undefined,
                        popupClassName: undefined,
                        dropdownClassName: undefined,
                        showOpenOptionOnHover: true,
                        defaultTargetOption: "_self",
                        options: ["link", "unlink"],
                        linkCallback: undefined,
                        titleCallback: undefined,
                        targetOption: undefined,
                        relOption: "nofollow",
                        linkTitle: false,
                        linkTarget: "_blank",
                        linkRel: "nofollow",
                      },
                      embedded: {
                        className: undefined,
                        component: undefined,
                        popupClassName: undefined,
                        embedCallback: undefined,
                        defaultSize: {
                          height: "auto",
                          width: "auto",
                        },
                      },
                      image: {
                        className: undefined,
                        component: undefined,
                        popupClassName: undefined,
                        urlEnabled: true,
                        uploadEnabled: true,
                        alignmentEnabled: true,
                        uploadCallback: undefined,
                        previewImage: false,
                        inputAccept:
                          "image/gif,image/jpeg,image/jpg,image/png,image/svg",
                        alt: { present: false, mandatory: false },
                        defaultSize: {
                          height: "auto",
                          width: "auto",
                        },
                      },
                    }}
                    wrapperStyle={{
                      height:
                        formData.notificationType === "email"
                          ? "200px"
                          : "100px",
                    }}
                    editorStyle={{ height: "100%", overflow: "auto" }}
                  />
                </div>
              ) : (
                <Form.Group controlId="formInfographicDescription">
                  <Form.Label
                    style={{ fontWeight: "500", borderRadius: "20px" }}
                  >
                    Description
                  </Form.Label>
                  <Form.Control
                    className="w-100"
                    style={{ width: "100%", borderRadius: "20px" }}
                    as="textarea"
                    rows={3}
                    name="description"
                    placeholder="Enter notification description"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                  />
                  {/* {formData.notificationType !== 'email' && ( // Render character count if notification type is not email
                                    <p style={{ color: 'grey', fontSize: '12px' }}>{formData.description.length}/70</p>
                                )} */}
                </Form.Group>
              )}
              <Form.Group
                controlId="notificationType"
                style={{ flexDirection: "row", display: "flex" }}
              >
                <Form.Label style={{ fontWeight: "500", borderRadius: "20px" }}>
                  Send Notification To:
                </Form.Label>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <div style={{ width: "10px" }} />
                  <Form.Check
                    type="radio"
                    label="All"
                    name="platform"
                    id="notificationAll"
                    value="all"
                    checked={formData.platform === "all"}
                    onChange={(e) =>
                      setFormData({ ...formData, platform: e.target.value })
                    }
                  />
                  <div style={{ width: "10px" }} />
                  <Form.Check
                    type="radio"
                    label="Email"
                    name="platform"
                    id="notificationEmail"
                    value="email"
                    checked={formData.platform === "email"}
                    onChange={(e) =>
                      setFormData({ ...formData, platform: e.target.value })
                    }
                  />
                  <div style={{ width: "10px" }} />
                  <Form.Check
                    type="radio"
                    label="Phone"
                    name="platform"
                    id="notificationPhone"
                    value="phone"
                    checked={formData.platform === "phone"}
                    onChange={(e) =>
                      setFormData({ ...formData, platform: e.target.value })
                    }
                  />
                </div>
              </Form.Group>
              <Button
                style={{
                  fontWeight: "600",
                  borderRadius: "20px",
                  marginTop: "15px",
                }}
                className="w-100"
                variant="primary"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : null}
                {isEdit ? "Edit" : "Create"} Notification
              </Button>
              <div style={{ height: "10px" }} />
            </Form>
          </Col>
        </Row>
      </Container>
    </Grid>
  );
};

export default NotificationsManage;
